export default __webpack_public_path__ + "static/3-04db7e51e524842ceded46959f731205.png";